import React, { useState } from "react";
import { Badge, ButtonGroup, FullscreenBar, Button, Link, Text } from "@shopify/polaris";
import { ViewMinor } from "@shopify/polaris-icons";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ThemeFullscreenBar({
  returnURL,
  activeTemplate,
  saveAction,
  discardAction,
  previewURL,
}) {
  const { t } = useTranslation();
  const [exited, setExited] = useState(false);
  if (exited) return <Navigate to={returnURL} />;

  const hasErrors = Object.keys(activeTemplate?.errors || {}).length;
  const isUnsaved = activeTemplate?.unsaved;

  return (
    <FullscreenBar onAction={() => setExited(true)}>
      <div
        style={{
          display: "flex",
          flexGrow: 1,
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: "1rem",
          paddingRight: "1rem",
        }}
      >
        <Text variant="headingLg" as="p">
          {activeTemplate?.name
            ? `${activeTemplate?.name} template`
            : t("common.loading")}
        </Text>

        <div style={{ marginLeft: "1rem", flexGrow: 1 }}>
          {hasErrors ? (
            <Badge status="critical">{t("themes.templates.badges.errors")}</Badge>
          ) : isUnsaved ? (
            <Badge status="info">{t("themes.templates.badges.unsaved")}</Badge>
          ) : null}
        </div>

        <ButtonGroup>
          <a
            target="_blank"
            href={previewURL}
            className="Polaris-Link Polaris-Link--removeUnderline"
          >
            {t("themes.templates.actions.viewTheme")}
          </a>
          <Button outline {...discardAction}>
            {t("themes.templates.actions.discard")}
          </Button>
          <Button primary {...saveAction}>
            {t("themes.templates.actions.save")}
          </Button>
        </ButtonGroup>
      </div>
    </FullscreenBar>
  );
}
